module.exports = __webpack_public_path__ + "static/assets/3bb387eac138f5f65fcc685d10d3a45e.svg";